export default class StringRequest {
  param: string
}
